import { keys } from "@/lib/i18n/portal";

const sellerSectionIndex = 3;
const sellerSubIndex = 4;
const adminSectionIndex = 2;
const adminSubIndex = 3;

export function getSellerMobileTitleKey(
  pathname: string | null,
  storeSlug: string,
): string {
  if (!pathname) {
    return keys.seller.dashboardTitle;
  }

  const segments = pathname.split("/").filter(Boolean);
  if (segments[1] !== "seller" || segments[2] !== storeSlug) {
    return keys.seller.dashboardTitle;
  }

  const section = segments[sellerSectionIndex];
  const sub = segments[sellerSubIndex];

  switch (section) {
    case "profile":
      return keys.seller.profileTitle;
    case "settings":
      return keys.seller.storeSettingsTitle;
    case "payment-details":
      if (sub === "new") {
        return keys.seller.paymentDetailsNewTitle;
      }
      if (sub) {
        return keys.seller.paymentDetailsEditTitle;
      }
      return keys.seller.paymentDetailsTitle;
    case "categories":
      if (sub === "new") {
        return keys.seller.categoriesNewTitle;
      }
      if (sub) {
        return keys.seller.categoriesEditTitle;
      }
      return keys.seller.categoriesTitle;
    case "products":
      if (sub === "new") {
        return keys.seller.productsNewTitle;
      }
      if (sub) {
        return keys.seller.productsEditTitle;
      }
      return keys.seller.productsTitle;
    case "orders":
      return keys.orders.title;
    default:
      return keys.seller.dashboardTitle;
  }
}

export function getAdminMobileTitleKey(pathname: string | null): string {
  if (!pathname) {
    return keys.admin.dashboardTitle;
  }

  const segments = pathname.split("/").filter(Boolean);
  if (segments[1] !== "admin") {
    return keys.admin.dashboardTitle;
  }

  const section = segments[adminSectionIndex];
  const sub = segments[adminSubIndex];

  switch (section) {
    case "profile":
      return keys.admin.profileTitle;
    case "admins":
      if (sub === "new") {
        return keys.admin.adminsNewTitle;
      }
      if (sub) {
        return keys.admin.adminsEditTitle;
      }
      return keys.admin.adminsTitle;
    case "sellers":
      if (sub === "new") {
        return keys.admin.sellersNewTitle;
      }
      if (sub) {
        return keys.admin.sellersEditTitle;
      }
      return keys.admin.sellersTitle;
    case "themes":
      if (sub === "new") {
        return keys.themes.newTitle;
      }
      if (sub) {
        return keys.themes.metadataTitle;
      }
      return keys.themes.title;
    case "stores":
      if (sub === "subscriptions") {
        return keys.admin.storeSubscriptionsTitle;
      }
      if (sub) {
        return keys.admin.storeDetailsTitle;
      }
      return keys.admin.storesTitle;
    case "subscriptions":
      return keys.admin.subscriptionsTitle;
    case "wallet-top-up-requests":
      return keys.admin.subscriptionTopUpRequestsTitle;
    case "integration-simulator":
      return keys.integrationSimulator.title;
    case "integration-logs":
      return keys.integrationLogs.title;
    case "areas":
      return keys.areas.nav;
    case "area-suggestions":
      return keys.areaSuggestions.title;
    case "app-configs":
      return keys.appConfigs.title;
    case "paid-services":
      return keys.paidServices.title;
    case "feature-flags":
      return keys.featureFlags.title;
    default:
      return keys.admin.dashboardTitle;
  }
}
